// Class sets of the Costs section. `landing` is the login page below the fold, always on
// the portal's dark blue; `themed` follows the user's theme (the recharging station).
// Full class names only: Tailwind keeps what it finds written in the sources.
const DARK = {
  section: 'bg-dark-blue text-white',
  text: 'text-white',
  muted: 'text-white/70',
  faint: 'text-white/50',
  accent: 'text-bright-blue',
  card: 'border border-white/10 bg-white/[0.04]',
  cardHover:
    'motion-safe:transition motion-safe:duration-300 hover:border-bright-blue/40 hover:bg-white/[0.07]',
  highlight: 'border-bright-blue/50 bg-bright-blue/[0.08]',
  chip: 'border border-bright-blue/30 bg-bright-blue/10 text-bright-blue',
  chipQuiet: 'border border-white/15 text-white/70',
  pill: 'bg-white/10 text-white',
  divider: 'border-white/10',
  link: 'text-bright-blue underline-offset-4 hover:underline hover:text-white',
  skeleton: 'bg-white/[0.06]',
  rail: 'bg-gradient-to-r from-sky-blue to-bright-blue',
  track: 'bg-white/10',
}

const LIGHT = {
  section: 'bg-transparent text-gray-900',
  text: 'text-gray-900',
  muted: 'text-gray-600',
  faint: 'text-gray-500',
  accent: 'text-sky-blue',
  card: 'border border-gray-200 bg-white',
  cardHover:
    'motion-safe:transition motion-safe:duration-300 hover:border-sky-blue/60 hover:shadow-md',
  highlight: 'border-sky-blue bg-light-blue/60',
  chip: 'border border-sky-blue/40 bg-light-blue text-mid-blue',
  chipQuiet: 'border border-gray-300 text-gray-600',
  pill: 'bg-light-blue text-mid-blue',
  divider: 'border-gray-200',
  link: 'text-blue underline-offset-4 hover:underline hover:text-mid-blue',
  skeleton: 'bg-gray-200',
  rail: 'bg-gradient-to-r from-pale-blue to-sky-blue',
  track: 'bg-gray-200',
}

export const costsTone = (variant, isDarkMode) =>
  variant === 'landing' || isDarkMode ? DARK : LIGHT
